module.exports = __webpack_public_path__ + "static/media/alarm-bell.21b4ef45.svg";